module.exports = __webpack_public_path__ + "static/media/union.a59443b1.svg";